import type { SVGProps } from "react";

export function IconBlackNavAppDeveloper(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_14330_429)">
        <path
          d="M15.0637 3.16479C16.4227 3.16496 17.5247 4.26673 17.5247 5.62573V9.38354H13.4153V20.1218H17.5159C17.4244 21.3975 16.3627 22.4039 15.0637 22.4041H5.21997C3.86087 22.4041 2.75903 21.3022 2.75903 19.9431V5.62573C2.75903 4.26663 3.86087 3.16479 5.21997 3.16479H15.0637ZM10.1418 6.96753C9.64763 6.96753 9.24634 7.36882 9.24634 7.86304C9.24645 8.35716 9.64769 8.75757 10.1418 8.75757C10.6359 8.75747 11.0363 8.3571 11.0364 7.86304C11.0364 7.36888 10.636 6.96763 10.1418 6.96753Z"
          fill="#0B0C17"
        />
        <path
          d="M18.4343 19.2034H14.3708V15.1438H18.4343V19.2034ZM23.116 19.2034H19.0535V15.1438H23.116V19.2034ZM18.4343 14.5256H14.3708V10.4661H18.4343V14.5256ZM23.1765 12.4495L21.1169 14.5071L19.0564 12.4495L21.1169 10.3909L23.1765 12.4495Z"
          fill="#0B0C17"
        />
      </g>
      <defs>
        <clipPath id="clip0_14330_429">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
